export const sliderItems = [
  {
    id: 1,
    img: "/slider/Furniture__Gateway_LP_LS_03.jpg",
    title: "Scandinavian Furniture",
    desc: "20% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "/slider/HEM_SUMMER_2017__3.jpg",
    title: "Swedish Furniture Brand",
    desc: "30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "/slider/slide_5_1024x1024.jpg",
    title: "Sofas & Chairs ",
    desc: "30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
]
